import React from 'react';
import styled from '@emotion/styled';
import { connectStats, connectCurrentRefinements } from 'react-instantsearch-dom';
import { formatNumber } from 'accounting-js';
import PropTypes from 'prop-types';

import { Heading } from './left-rail-shared';

const RefinementHeading = styled(Heading)(({ total }) => ({
  borderBottom: total ? 0 : undefined
}));

const RefinementsHeader = ({ isBrandRefined, nbHits, items }) => {
  const filterItems = [
    ...new Map(
      items
        .filter((item) => {
          const flags = item.attribute !== 'edits' && item.attribute !== 'trends' && item.items;
          return isBrandRefined ? item.attribute !== 'brand' && flags : flags;
        })
        .map((item) => [item.id, item])
    ).values()
  ];

  const price = items.find((item) => item.id === 'variants.maisonette_sale');

  const total = filterItems
    .filter((item) => item.items)
    .reduce((sum, curr) => sum + curr.items.length, price ? 1 : 0);

  return (
    <RefinementHeading
      role="heading"
      aria-level="2"
      element="label"
      like="label-1"
      total={total}
    >
      { total > 0 ? `Filters (${total})` : 'Filters' }
      <span>{`${formatNumber(nbHits, { precision: 0 })} items`}</span>
    </RefinementHeading>
  );
};

RefinementsHeader.defaultProps = {
  nbHits: 0,
  isBrandRefined: false,
  items: []
};

RefinementsHeader.propTypes = {
  isBrandRefined: PropTypes.bool,
  nbHits: PropTypes.number,
  items: PropTypes.array
};

export default connectStats(connectCurrentRefinements(RefinementsHeader));
